import ApplicationSerializer from './application';

export default class GroupInviteLinkSerializer extends ApplicationSerializer {
  attrs = {
    publicToken: { serialize: false },
    publicUrl: { serialize: false },
    consumedCount: { serialize: false },
    remainingCapacity: { serialize: false },
    active: { serialize: false },
    lastHeartbeatAt: { serialize: false },
    createdAt: { serialize: false },
    updatedAt: { serialize: false },
  };
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'group-invite-link': GroupInviteLinkSerializer;
  }
}
